export default function searchUrl(
    $q,
    searchBarFactory,
    UrlFactory,
    Basket,
    $location,
    Error
) {
    var factory = this;

    factory.firstLoad = true;

    /**
     * What this will do
     *
     * Load search from url
     */

    factory.init = function () {
        /**
         * get from url
         */

        const urlParams = UrlFactory.getParamsFromUrl();

        /**
         * feature : check date and time
         * Work in progress
         */
        // UrlFactory.checkDateTime(urlParams); //if url date/time is in the past?

        /**
         * async - request collection of items frm API ($q all)
         */
        return UrlFactory.getCollection(
            urlParams.activityName,
            urlParams.locationName,
            urlParams.date,
            urlParams.start,
            urlParams.end,
            urlParams.hours,
            urlParams.weeks
        ).then(function (res) {
            /**
             * set as null if error from API
             * None found or non given
             *
             * */

            const collection = {
                activity: res.activity instanceof Error ? null : res.activity,
                location: res.location instanceof Error ? null : res.location,
                date: res.date instanceof Error ? null : res.date,
                start: res.start instanceof Error ? null : res.start,
                end: res.end instanceof Error ? null : res.end,
                hours: res.hours instanceof Error ? null : res.hours,
                weeks: res.hours instanceof Error ? null : res.weeks,
            };

            /**
             * Update the SearchBar
             */

            // setSearchFilterService
            UrlFactory.setSearchFilterService(
                collection.activity,
                collection.location,
                collection.date,
                collection.start,
                collection.end,
                collection.hours,
                collection.weeks
            );

            /**
             * switch to searchbar format
             */

            searchBarFactory.updateSearchBar(
                collection.activity,
                collection.location,
                collection.date,
                collection.start,
                collection.end,
                collection.hours
            );

            /**
             * Trigger a Search
             */
            let setRoute = false; // deafult true
            searchBarFactory.searchBroadcast(setRoute);

            Basket.setSearchPeriodsUrl($location.$$url);

            return $q.resolve(collection);
        });
    };

    // factory.init();

    return factory;
}
